/**
 * Utility functions for strings
 *
 * @module component/util/string
 */

/**
 * Convert a string to title case.
 *
 * Title case is where every word in a sentence has its first letter
 * capitalized.
 *
 * @param {string} s
 * The string to convert into title case
 *
 * @returns {string}
 * Returns the string given to the s parameter converted to title case.
 *
 * @throws {TypeError}
 * An exception is thrown if the s parameter is not a string object
 *
 * @example
 * let sentence = 'Hello world again'
 *
 * // title is set to 'Hello World Again'
 * let title = titlecase(sentence)
 *
 */
export function titlecase(s) {
    let s_type = typeof s;
    if (s_type !== 'string') {
        let errmsg = `Expected arg w/ string type, got ${s_type} type instead`;
        throw new TypeError(errmsg);
    }

    let ret = s
        .split(/\s/)
        .map(w => {
            let head = w.charAt(0).toLocaleUpperCase();
            let tail = w.slice(1);
            return head + tail;
        })
        .join(' ');

    return ret;
}
